<template>
  <div style="left: 0">
    <br><br>
    <!-- ///////////////////////////////////////////////////
    /////////// C A R R U S E L - V E R T I C A L ///////////
    /////////////////////////////////////////////////////////-->
    <div class="is-hidden-touch" style="background: #002f59; top: 0; min-width: 19rem; left: 0;bottom: 0"></div>
    <aside class="sidebar-vertical menu is-hidden-touch content-notice-list">
      <div class="head-sidebar"></div>
      <ul>

        <li :key="model.id" v-for="model in vertical"
            class="menu-list cd-accordion-menu ul-notice-list">

          <sidebar-item :model="model"></sidebar-item>
        </li>

      </ul>


    </aside>
  </div>
</template>
<script>
  import SidebarItem from './TheNoticeItem'
  const endpointBase = __API__
  export default {
    components:{SidebarItem},
    data() {
      return {
        vertical: null,
        open: false,
        data:[],
        endpointBase,
      }
    },
    mounted() {
      this.$http.get('images/noticia')
        .then((response) => {
          console.log(response.data);
          this.vertical = response.data;
        });
    },
    methods:{
      toggle: function(){
        //this.open = !this.open;
      }
    },
    computed: {
      datosMenu() {
        return{
          vertical: []
        }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/TheNotice.vue